import { render, staticRenderFns } from "./form3License.vue?vue&type=template&id=197b7997&scoped=true"
import script from "./form3License.vue?vue&type=script&lang=js"
export * from "./form3License.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197b7997",
  null
  
)

export default component.exports